import { Position } from "@turf/turf";
import L, { Layer, Map } from "leaflet";
import { AgroMap } from "@/features/map/utils/agromap";
import { MapType } from "@/features/map/utils/agromap.type";
import { Farm } from "@/features/farm/domain/farm.interface";
import { Validation } from "@/features/map/domain/agromap.interface";
import { Season } from "@/features/growing-season/domain/growing-season.interface";

export class FarmMap extends AgroMap {
  constructor(
    popupRef: React.RefObject<HTMLDivElement>,
    toolbarOptions: L.PM.ToolbarOptions,
    markerIcon: L.Icon<L.IconOptions> | L.DivIcon,
    private _type: MapType,
    private _farmerFarms?: Farm[],
    private _farmSeasons?: Season[],
    private _currentFarmPolygon?: Position[]
  ) {
    super(popupRef, toolbarOptions, _type !== "onlyShow", markerIcon);
  }

  validate(polygon: Position[]): Validation {
    let validation: Validation = { isValid: true, message: "" };
    this._farmerFarms &&
      this._farmerFarms.forEach((farm) => {
        // برای بررسی حالتی که زمین رسم شده کل زمین (ها) را در بر بگیرد
        if (super.isPolygonInPolygon(polygon, farm.polygon)) {
          validation = super.validationResult(
            false,
            "زمین رسم شده با سایر زمین ها تداخل دارد"
          );
        }
        // برای بررسی حالتی که زمین رسم شده زمین (ها) دیگر را قطع کند
        if (super.isPolygonIntersectedPolygon(polygon, farm.polygon)) {
          validation = super.validationResult(
            false,
            "زمین رسم شده با سایر زمین ها تداخل دارد"
          );
        }
      });

    this._farmSeasons?.forEach((season) => {
      if (!super.isPolygonInPolygon(polygon, season.polygon)) {
        validation = super.validationResult(
          false,
          "زمین رسم شده با فصل رشدی هایش تداخل دارد"
        );
      }
    });

    return validation;
  }

  methodWhenCreateEventFired(map: Map, layer: L.Layer): void {
    super.setPolygonDetails(
      super.layerToCoordinates(layer),
      "[longitude | latitude]"
    );
  }

  methodWhenDrawEnd(map: Map): void {
    // ویرایش زمین بعد از رسم آن توسط کاربر در حالت افزودن زمین
    map.pm.getGeomanLayers()?.forEach((layer) => {
      layer.on("pm:edit", (e) => {
        if (this._type === "add") {
          this.methodWhenEditEventFired(layer);
        }
      });

      layer.on("pm:markerdrag", (event) => {
        // @ts-ignore
        this.methodWhenMarkerDrag(event.markerEvent.target._latlng, layer);
      });
    });
  }

  methodWhenMarkerDrag(_latlng: L.LatLng, layer: Layer): void {
    super.setPolygonDetails(
      super.layerToCoordinates(layer),
      "[longitude | latitude]"
    );
  }

  methodWhenEditEventFired(layer: L.Layer): void {
    const editedPolygon = (super.layerToCoordinates(layer) as Position[]).map(
      (coordinate) => [coordinate[1], coordinate[0]]
    );
    super.setPolygonDetails(editedPolygon, "[latitude | longitude]");
  }
}
